export const GOOGLE_MAPS_SCRIPT_ID = "google-map-script";
export const GOOGLE_MAPS_API_KEY = "AIzaSyBdRBI4rB5GSupDdAWAlPTXDGIGqlBmbyQ";

export const googleMapsLoaderOptions = {
  id: GOOGLE_MAPS_SCRIPT_ID,
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
};
